import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/product-list/[id]/page.client.tsx");
